import React, { useEffect, useState } from "react";
import { showToast } from "../../../services/toastifyservices";
import { handleSession } from "../../../api/apiSessionHandle";
import { useNavigate } from "react-router-dom";
import {
  getaxiosadminRequestWithToken,
  postaxiosadminRequestWithToken,
  getAdminAssistentsPool,
} from "../../../api/api";
import { FaEdit } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { Spinner } from "react-bootstrap";
import CommonSpinner from "../../../services/commonSpinner";
import AssistantDetail from "../../../components/Assistant/AssistantDetails";
import Swal from "sweetalert2";
import { PaginationControls } from "../../../components/pagination";
import RoleDropdown from "../../../components/Assistant/RoleDropdown";
import endpoints from "../../../api/EndPoints";

const Assistants = () => {
  const navigate = useNavigate();
  const [adminAssistant, setAdminAssistant] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnloading, setbtnLoading] = useState(false);
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [isNew, setIsNew] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedrole, setSelectedrole] = useState("Assistant");
  const [SelectedName, setSelectedName] = useState("");

  //! Pagination state
  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();

  useEffect(() => {
    GetAssistantData("active", "Assistant");
  }, []);

  const GetAssistantData = async (status, role) => {
    try {
      let payload = {
        status: status || "active",
        role: role || "Assistant",
        input: SelectedName,
      };
      setLoading(true);
      const response = await getaxiosadminRequestWithToken(
        endpoints.GetAllAssistant,
        payload
      );
      if (response.success) {
        var responsedata = response.data;
        console.log("responsedata", responsedata);

        setAdminAssistant(responsedata.data);
        setRowsPerPage(responsedata.per_page);
        setCurrentPage(responsedata.current_page);
        setTotalPages(Math.ceil(responsedata.total / responsedata.per_page));
      }
    } catch (error) {
      setLoading(false);
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    showToast(
      "error",
      error.response?.data?.message || "Something went wrong."
    );
    handleSession(error.response?.data, navigate);
  };

  const handleEdit = (rowData) => {
    setSelectedAssistant(rowData);
    setIsNew(false);
    setShowModal(true);
  };

  const handleAddNew = () => {
    setSelectedAssistant(null);
    setIsNew(true);
    setShowModal(true);
  };

  const UpdateAssistantData = async (data) => {
    setbtnLoading(true);

    let endPoint = "";
    let payload = {};

    const { id, name, email, password, status, role } = data;

    if (isNew) {
      endPoint = endpoints.CreateAssistant;
      payload = { name, email, password, role };
    } else {
      endPoint = endpoints.UpdateAssistant;
      payload = { id, name, email, status, role};
    }

    try {
      const response = await postaxiosadminRequestWithToken(endPoint, payload);
      if (response.success) {
        showToast("success", response.message);
        await GetAssistantData("active", selectedrole);
        setShowModal(false);
        setIsNew(true);
        setSelectedAssistant("");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setbtnLoading(false);
    }
  };

  // const handleDelete = async (id) => {
  //   Swal.fire({
  //     title: "Do you want to delete this?",
  //     showCancelButton: true,
  //     confirmButtonText: "Delete",
  //     cancelButtonText: "Cancel",
  //     icon: "question",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         const params = { id, status: "deleted" };
  //         const response = await postaxiosadminRequestWithToken(
  //           "update-assistant",
  //           params
  //         );

  //         if (response.success) {
  //           showToast("success", "Assistant deleted successfully");
  //           await GetAssistantData("active", selectedrole);
  //         } else {
  //           showToast(
  //             "error",
  //             response.message || "Failed to delete the assistant"
  //           );
  //         }
  //       } catch (error) {
  //         showToast("error", error.response?.data.message);
  //       }
  //     }
  //   });
  // };

  const handlePageChange = (page) => {
    ;
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      fetchAdminAssistant(page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    fetchAdminAssistant(currentPage, newLimit);
  };

  const fetchAdminAssistant = async (page, limit = rowsPerPage) => {
    // if (pageCache.current[page]?.limit === limit) {
    //   const cachedData = pageCache.current[page];
    //   setMedicalAssignProgram(cachedData.data);
    //   setCurrentPage(cachedData.current_page);
    //   setTotalPages(cachedData.last_page);
    //   setLoading(false);
    //   return;
    // }
    setLoading(true);
    try {
      const response = await getAdminAssistentsPool(
        page,
        limit,
        selectedStatus
      );
      if (response) {
        const { data, current_page, last_page } = response.data;
        //        pageCache.current[page] = { data, current_page, last_page, limit };
        setAdminAssistant(data);
        setCurrentPage(current_page);
        setTotalPages(last_page);
      }
    } catch (error) {
      handleSession(error.response?.data, navigate);
      console.error("Error fetching patients:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    GetAssistantData(selectedStatus, selectedrole);
  };

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Manage Assistant
        </span>
      </div>
      <div className="card p-3">
        <div className="row d-flex align-items-end justify-content-between">
          <div className="col-md-3">
            <label className="form-label font-bold">Name</label>
            <input
              type="text"
              className="form-control"
              value={SelectedName}
              onChange={(e) => setSelectedName(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label font-bold">Status</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">Select status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label font-bold">Role</label>
            <RoleDropdown name="role" value={selectedrole} onChange={(e) => setSelectedrole(e.target.value)} />
          </div>

          {/* Buttons section - Using d-flex to keep them aligned */}
          <div className="col-md-3 d-flex justify-content-between">
            <button
              className="btn btn-primary fw-bold btncolor"
              onClick={handleSearch}
            >
              SEARCH
            </button>

            <button
              className="btn btn-primary fw-bold btncolor"
              onClick={handleAddNew}
            >
              ADD NEW
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="table table-striped table-hover">
            <thead className="table-header table-primary">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {loading ? (
                <tr></tr>
              ) : adminAssistant.length > 0 ? (
                adminAssistant.map((data, index) => (
                  <tr key={index}>
                    <td>{data.name}</td>
                    <td>{data.email}</td>
                    <td>{data.status.charAt(0).toUpperCase() + data.status.slice(1)}</td>
                    <td>
                      {data.status.toLowerCase() === "active" && (
                        <>
                          <button
                            onClick={() => handleEdit(data)}
                            className="btn btn-sm btn-primary"
                          >
                            <FaEdit style={{ cursor: "pointer" }} />{" "}
                          </button>
                          {/* <button
                            onClick={() => handleDelete(data.id)}
                            className="btn btn-link"
                            title="Delete Assistant"
                            style={{ color: "red" }}
                          >
                            <FiTrash2 size={20} />
                          </button> */}
                        </>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {loading ? null : (
        <div className="pagination-controls">
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onLimitPerPage={handleRowsPerPageChange}
          />
        </div>
      )}

      {loading && <CommonSpinner />}

      <AssistantDetail
        selectedAssistant={selectedAssistant}
        isNew={isNew}
        UpdateAssistantData={UpdateAssistantData}
        showModal={showModal}
        setShowModal={setShowModal}
        btnloading={btnloading}
      />
    </div>
  );
};

export default Assistants;
